export var paymentOptions = function (paymentOptions) {
  paymentOptions["PAY_NOW"] = "PAY_NOW";
  paymentOptions["PAY_ON_ARRIVAL"] = "PAY_ON_ARRIVAL";
  paymentOptions["RESERVE_WITHOUT_CARD"] = "RESERVE_WITHOUT_CARD";
  paymentOptions["ACCOUNT_TO_COMPANY"] = "ACCOUNT_COMPANY";
  return paymentOptions;
}({});